import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import GrupoKrause from "../pages/GrupoKrause";
import Destaques from "../pages/Destaques";
import Noticia from "../pages/Noticia";
import OndeEstamos from "../pages/OndeEstamos";
import TrabaheConosco from "../pages/TrabalheConosco";
import Contato from "../pages/Contato";
import Funeraria from "../pages/Funeraria";
import Assistencial from "../pages/Assistencial";
import Memorial from "../pages/Memorial";
import MaisQuePet from "../pages/MaisQuePet";
import PequenosCometas from "../pages/PequenosCometas";
import VelasVirtuais from "../pages/VelasVirtuais";
import Estrelinhas from "../pages/Estrelinhas";
import Privacidade from "../pages/Privacidade";
import FuneralDistancia from "../pages/FuneralDistancia";
import Error from "../pages/Error";

export default function PagesRoutes() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route element={<GrupoKrause />} path="/quem-somos/" />
      <Route element={<Destaques />} path="/destaques/" />
      <Route element={<Noticia />} path="/destaques/:slug" />
      <Route element={<OndeEstamos />} path="/onde-estamos/" />
      <Route element={<TrabaheConosco />} path="/trabalhe-conosco/" />
      <Route element={<Contato />} path="/contato/" />
      <Route element={<Funeraria />} path="/servicos/funeraria-krause/" />
      <Route element={<Assistencial />} path="/servicos/krause-assistencial/" />
      <Route element={<Memorial />} path="/servicos/memorial-krause/" />
      <Route element={<MaisQuePet />} path="/servicos/mais-que-pet/" />
      <Route element={<PequenosCometas />} path="/servicos/pequenos-cometas/" />
      <Route element={<VelasVirtuais />} path="/velas-virtuais" />
      <Route element={<Estrelinhas />} path="/estrelinhas" />
      <Route element={<Privacidade />} path="/privacidade/" />
      <Route element={<FuneralDistancia />} path="/funeral-a-distancia/" />
      <Route element={<Error />} path="*" />
    </Routes>
  );
}
